<template>
  <o-view>
    <o-nav-bar title="Tanken" :has-back-button="true" />
    <o-map />
    <o-block-list title="Kies een product">
      <o-list-item
        icon="brands-q8"
        icon-style="logo"
        label="Q8 Fuel on the go"
        link="/sales/fuel/q8/onboarding/account"
      />
    </o-block-list>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'

export default {
  name: 'Bike',
  components: {
    OMap
  }
}
</script>
